import { Reveal } from "./Reveal";

const MARQUEE = [
  "Czech Warmbloods",
  "Hunters",
  "Show Jumpers",
  "Equitation",
  "Imports",
  "Brokerage",
  "Coconut Creek, FL",
];

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section
      data-testid="marquee-strip"
      aria-hidden
      className="bg-[#F9F9F6] border-y hairline overflow-hidden py-8"
    >
      <div className="flex marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-display text-3xl md:text-5xl tracking-tighter mx-8 text-[#1A2B22]"
          >
            {t}
            <span className="mx-8 text-[#965C3B]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

const STATS = [
  { k: "Sourced", v: "Europe" },
  { k: "Specialty", v: "Czech Warmbloods" },
  { k: "Disciplines", v: "Hunter · Jumper · Eq" },
  { k: "Located", v: "Coconut Creek, FL" },
];

export const StatBand = () => (
  <section
    data-testid="stat-band"
    className="bg-[#F9F9F6] border-b hairline px-6 md:px-12 lg:px-24 py-12"
  >
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
      {STATS.map((s, i) => (
        <Reveal key={s.k} delay={i * 80}>
          <div className="border-t hairline pt-5">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#5C6A61]">
              {s.k}
            </p>
            <p className="mt-2 font-display text-xl md:text-2xl tracking-tighter text-[#1A2B22]">
              {s.v}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Marquee;
